import * as AccommodationService from '~/services/AccommodationService';

import { CatalogItemConfig } from '../types/catalogItem';

export const amenityConfig: CatalogItemConfig<
  AccommodationService.AdminAmenity,
  AccommodationService.AmenityUpdatePayload,
  AccommodationService.AmenityCreatePayload,
  AccommodationService.ApproveAmenityPayload,
  AccommodationService.MergeAmenityPayload
> = {
  // Service methods
  listItems: async (params) => {
    const response = await AccommodationService.listAmenities({
      ...params,
      // AccommodationService.listAmenities expects a required literal union here.
      status: (params.status ?? 'approved') as 'approved' | 'draft',
    });
    return {
      ...response,
      result: {
        items: response.result.amenities,
        total: response.result.total,
      },
    };
  },
  updateItem: AccommodationService.updateAmenity,
  createItem: AccommodationService.createAmenity,
  deleteItem: AccommodationService.deleteAmenity,
  approveItem: AccommodationService.approveAmenity,
  discardItem: AccommodationService.discardAmenity,
  mergeItem: AccommodationService.mergeAmenity,

  // Query keys
  queryKeyPrefix: 'amenities',

  // Labels
  itemName: 'Amenity',
  itemNamePlural: 'Amenities',

  // Type
  type: 'amenity',
};
